<!--
 * @Author: dengyaxin dengyaxin@xiaokunkeji.com
 * @Date: 2023-12-07 11:42:24
 * @LastEditors: dengyaxin dengyaxin@xiaokunkeji.com
 * @LastEditTime: 2023-12-16 16:15:22
 * @FilePath: /web-shop/src/pages/record/month.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="_content">
    <section class="month-record">
      <!-- 背景图 -->
      <img class="bg" src="https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png" alt=""
        srcset="" />
      <section class="page-content">
        <RecordList :dataList="dataList" :tabList="tabList" @goPage="goPage">
          <template #top>
            {{ queryMonth }}
          </template>
        </RecordList>
      </section>
    </section>
  </div>
</template>

<script>
import RecordList from "./components/list.vue";
import moment from 'moment';
import config from '@/configs/config';
export default {
  components: { RecordList },
  data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png',
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png',
        },
      },
      queryMonth: "",//查询月
      shopId:'',
    };
  },
  mounted() {
    this.queryMonth = moment(tuhu.getParam("date")).format("YYYY年MM月")
    this.shopId=tuhu.getParam("shopId")||JSON.parse(localStorage.getItem("_xk_user_key"))['shopId']
    this.queryDataList()
  },
  methods: {
    goPage(row) {
      tuhu.navigateTo({
        url: `/pages/dayRecord/index?date=${row.countTime}&shopId=${this.shopId}`,
      });
    },
    async queryDataList() {
      tuhu.showIndicator()
      let year=moment(tuhu.getParam("date")).format("YYYY")
      const res = await tuhu.fetch(`${config.apis.GET_TIKTOK_ORDER_YEAR_RECORD}?shopId=${this.shopId}&year=${year}`);
      tuhu.hideIndicator();
      if (res && res.code === '200') {
        let yearData=res&&res.data&&res.data.monthList.length?res.data.monthList.filter(item=>{
          if(item.month===tuhu.getParam("date"))return item
        }):[]
        this.handleData(yearData[0])
      } else {
        tuhu.toast(res.message || "网络错误");
      }
    },
    //获取列表数据
    handleData(obj) {
      // const data = JSON.parse(localStorage.getItem('monthList'))
      const data = {...obj}
      for (const key in this.tabList) {
        this.tabList[key]['num'] = data[key] || 0
      }
      console.log(data.dayOrders,"lllll")
      this.dataList = data&&data.dayOrders.map(item => {
        item.count=item.verifyOrderSum;
        item.date=moment(item.countTime).format("YYYY年MM月DD日")
        item.price = item.orderAmountSum;
        return item
      })
    },
  },
};
</script>
<style lang="less" scoped>
._content {
  background: #f8f9fb;

  .month-record {
    .bg {
      width: 100%;
      height: 14.85rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/record/month.vue